import Api from "./Api";

export default {
    getAllLeadList(payload) {
        let AllLeadList = Api().post(
            "Lead/getAllLeads.php",
            payload
        );
        return AllLeadList;
    },
    getMultiUpdate(payload) {
        let AllLeadList = Api().post(
            "Api_Common/viewAssignmentMultiUpdateDetails.php",
            payload
        );
        return AllLeadList;
    },
    getAllEnqPricingList(payload) {
        let AllEnqPricingList = Api().post(
            "Lead/getAllEnqPricing.php",
            payload
        );
        return AllEnqPricingList;
    },
    getClientLeadList(payload) {
        let allLeadClientList = Api().post(
            "Lead/getAllEnqPricing.php",
            payload
          );
          return allLeadClientList;
    },
};



// WEBPACK FOOTER //
// ./src/services/LeadService.js